import type { ComponentType } from 'react';
import { views } from '@/copy';
import AssistantVisualFrame from './AssistantVisualFrame';
import type { Breadcrumb, VisualFrameProps } from '../types';

/**
 * Placeholder for a self card whose response is valid but carries no data for this
 * (entity × geo × source) intersection. Persistent surfaces (report tiles) render
 * this so the widget explains itself; chat hides the card instead (renders nothing).
 * The breadcrumb supplies the geo · source context, so the body stays concise.
 */
const InlineCardEmpty = ({
    breadcrumb,
    typeLabel,
    Frame = AssistantVisualFrame,
}: {
    breadcrumb: Breadcrumb;
    typeLabel: string;
    Frame?: ComponentType<VisualFrameProps>;
}) => (
    <Frame breadcrumb={breadcrumb}>
        <div className="bg-card border border-border rounded-xl shadow-xs p-4 text-sm text-muted-foreground">
            {views.assistantVisuals.noData(typeLabel)}
        </div>
    </Frame>
);

export default InlineCardEmpty;
